<template>
  <svg
    fill="none"
    height="30"
    viewBox="0 0 30 30"
    width="30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.03691 14.9212C2.77288 12.7171 2.16255 10.9173 1.79453 9.09299C1.25024 6.39481 2.49583 3.75911 4.55926 2.07734C5.43134 1.36655 6.43106 1.60939 6.94675 2.53457L8.11099 4.62325C9.0338 6.27879 9.49521 7.10656 9.40369 7.98416C9.31217 8.86176 8.68991 9.57652 7.44538 11.006L4.03691 14.9212ZM4.03691 14.9212C6.59542 19.3824 10.6105 23.3997 15.0769 25.9612M15.0769 25.9612C17.281 27.2252 19.0808 27.8356 20.9051 28.2036C23.6033 28.7479 26.239 27.5023 27.9208 25.4389C28.6316 24.5668 28.3887 23.5671 27.4636 23.0514L25.3749 21.8871C23.7193 20.9643 22.8916 20.5029 22.014 20.5944C21.1364 20.686 20.4216 21.3082 18.9921 22.5527L15.0769 25.9612Z"
      stroke="#49779D"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M17.6667 8.10717C19.5644 8.91302 21.0851 10.4337 21.891 12.3314M18.5388 1.6647C23.2551 3.02572 26.9722 6.74273 28.3334 11.4589"
      stroke="#49779D"
      stroke-linecap="round"
      stroke-width="1.5"
    />
  </svg>
</template>
